(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["codex-family-extras"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cf-family-extras')) {
  customElements.define('cf-family-extras', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.data = JSON.parse(this.querySelector('script').textContent);
      this.panel = this.querySelector('.cf-extra-panel');
      this.family = this.previousElementSibling?.classList.contains('cf-family') ? this.previousElementSibling : null;
      this.bar = this.family?.querySelector('.cf-family__versions');
      if (!this.bar) { this.bar = document.createElement('div'); this.bar.className='cf-family__versions'; this.prepend(this.bar); }
      this.modelNav = this.family?.querySelector('.cf-family__models')?.parentElement;
      this.buttons = [];
      this.cache = {};
      for (const kind of ['combos','retro']) {
        if (!this.data[kind]?.length) continue;
        const button=document.createElement('button'); button.type='button'; button.className='cf-family__version cf-extra-button';
        button.textContent=this.dataset[kind]; button.setAttribute('aria-expanded','false');
        button.addEventListener('click',()=>this.show(kind,button)); this.bar.append(button); this.buttons.push(button);
      }
    }
    async show(kind,button) {
      const close = button.getAttribute('aria-expanded') === 'true';
      this.buttons.forEach(b=>{b.setAttribute('aria-expanded','false');b.classList.remove('is-current');});
      this.panel.hidden=close; if(this.modelNav) this.modelNav.hidden=!close;
      if(close){this.current=null;return;}
      this.current=kind;button.setAttribute('aria-expanded','true');button.classList.add('is-current');
      this.panel.replaceChildren(); const status=document.createElement('p');status.className='cf-extra-status';status.setAttribute('role','status');status.textContent=this.dataset.loading;this.panel.append(status);
      const root=this.dataset.root.replace(/\/$/,'');
      try {
        if(!this.cache[kind]) {
          const result=[]; const entries=this.data[kind];
          for(let offset=0;offset<entries.length;offset+=4) {
            const batch=await Promise.all(entries.slice(offset,offset+4).map(async entry=>{
              const response=await fetch(`${root}/products/${encodeURIComponent(entry.handle)}.js`,{signal:AbortSignal.timeout(12000)});
              if(response.status===404)return null;
              if(!response.ok)throw new Error('product unavailable');return response.json();
            })); result.push(...batch);
          }
          this.cache[kind]=result;
        }
        if(this.current!==kind)return;
        this.panel.replaceChildren(); const grid=document.createElement('div');grid.className='cf-extra-grid';
        for(const product of this.cache[kind]) {
          if(!product || !product.available || !product.featured_image)continue;
          const link=document.createElement('a');link.className='cf-extra-card';link.href=`${root}/products/${encodeURIComponent(product.handle)}`;
          if(product.handle===this.dataset.product)link.setAttribute('aria-current','page');
          const img=document.createElement('img');const src=new URL(product.featured_image,location.origin);src.searchParams.set('width','320');img.src=src.href;img.alt=product.title;img.loading='lazy';img.width=320;img.height=320;
          const text=document.createElement('span');text.textContent=product.title;link.append(img,text);grid.append(link);
        }
        if(grid.childElementCount)this.panel.append(grid);else{status.textContent=this.dataset.empty;this.panel.append(status);}
      } catch(error) {if(this.current===kind){this.panel.replaceChildren();status.textContent=this.dataset.error;this.panel.append(status);}}
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
